import type { AnimeRole } from "@/types";

export const animeRoles: AnimeRole[] = [
  {
    id: "shirayuki-yukino",
    name: "白羽雪乃",
    alias: "Yukino / 白雪公主",
    work: "星霜少女",
    workDesc: "《星霜少女》是一部讲述少女们在冻结世界中寻找春天的奇幻成长物语。",
    tags: ["冷系", "优雅"],
    attributes: ["银发", "长发", "和服"],
    cv: "花泽香菜",
    age: "15 岁",
    personality: "外冷内热，沉默寡言却极重情义",
    firstAppear: "第 1 话「初雪」",
    popularity: 9820,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20long%20silver%20hair%20wearing%20elegant%20white%20kimono%2C%20soft%20pastel%20pink%20background%2C%20gentle%20snowflakes%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-01&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20silver%20hair%20standing%20in%20quiet%20snowy%20garden%2C%20soft%20pink%20pastel%20palette%2C%20kawaii%20anime%20illustration%2C%20wholesome%20scene&width=800&height=600&seq=role-g-01a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20silver%20hair%20holding%20paper%20umbrella%20under%20cherry%20blossom%20tree%2C%20pastel%20pink%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-01b&orientation=landscape"
    ],
    description: "白羽雪乃是一个气质清冷的银发少女，一袭白衣如雪。她话不多，却在每一次危机中第一个站出来保护同伴，是团队里最让人安心的存在。",
    story: "雪乃出生于常年飘雪的北境村落，自幼便能听见「霜之声」。她与同伴们一同踏上寻找世界尽头的旅途，在一次次相遇与离别中，渐渐学会表达自己的情绪，也明白了温柔并不等于软弱。"
  },
  {
    id: "momose-suzune",
    name: "桃濑小铃",
    alias: "Suzune / 小铃铛",
    work: "森之魔法语",
    workDesc: "《森之魔法语》讲述见习魔女与森林精灵共同守护秘境的治愈日常。",
    tags: ["萌系", "元气"],
    attributes: ["粉发", "双马尾", "魔法帽"],
    cv: "悠木碧",
    age: "13 岁",
    personality: "天真烂漫，冒失却永不放弃",
    firstAppear: "第 1 话「会说话的森林」",
    popularity: 9650,
    isNew: true,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20pink%20twin%20tails%20and%20magical%20hat%2C%20sparkling%20pastel%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-02&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20pink%20hair%20casting%20sparkly%20magic%20in%20enchanted%20forest%2C%20pastel%20palette%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-02a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20pink%20hair%20with%20forest%20spirit%20companion%2C%20soft%20green%20and%20pink%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-02b&orientation=landscape"
    ],
    description: "桃濑小铃是一名见习魔女，头顶 oversized 的魔法帽比她还高。她总是念错咒语，却用最笨拙的真诚治愈了整片森林，是萌系角色的教科书范本。",
    story: "小铃来自魔法学校，因为一次失败的传送术误入禁忌森林，从此与森林守护精灵缔结契约。她用一次次失败的魔法，换来了最珍贵的友情与成长。"
  },
  {
    id: "hoshino-alice",
    name: "星野爱丽丝",
    alias: "Alice / 星星收藏家",
    work: "天空寮的日常",
    workDesc: "《天空寮的日常》描绘一群少女在漂浮于云端的学生宿舍里的暖心群像。",
    tags: ["元气", "天然"],
    attributes: ["金发", "短发", "学院制服"],
    cv: "佐仓绫音",
    age: "14 岁",
    personality: "活泼开朗，是全场的气氛担当",
    firstAppear: "第 1 话「云端宿舍」",
    popularity: 9410,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20short%20blonde%20hair%20and%20school%20uniform%2C%20bright%20sky%20pastel%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-03&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20blonde%20hair%20running%20on%20cloud%20dormitory%20rooftop%2C%20bright%20pastel%20sky%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-03a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20blonde%20hair%20watching%20stars%20with%20friends%2C%20warm%20pastel%20night%20scene%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-03b&orientation=landscape"
    ],
    description: "星野爱丽丝总能第一时间发现别人的不开心，然后强行把快乐塞给对方。她的笑容像会传染一样，是天空寮当之无愧的太阳。",
    story: "爱丽丝在漂浮宿舍的天台收集「会说话的星星」，每收集一颗就许下一个愿望。她的梦想是让所有孤单的人都能拥有一个可以回的家。"
  },
  {
    id: "kurobane-yoru",
    name: "黑羽夜",
    alias: "Yoru / 夜之刃",
    work: "幻夜学园",
    workDesc: "《幻夜学园》讲述近代都市里，少女们对抗「夜蚀」的黑暗奇幻故事。",
    tags: ["冷系", "傲娇"],
    attributes: ["黑发", "长发", "眼镜"],
    cv: "早见沙织",
    age: "16 岁",
    personality: "毒舌强势，实则把伙伴的安危看得比谁重",
    firstAppear: "第 2 话「夜蚀降临」",
    popularity: 9180,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20long%20black%20hair%20and%20glasses%2C%20deep%20night%20purple%20pastel%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-04&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20black%20hair%20holding%20blade%20in%20moonlit%20city%2C%20purple%20pastel%20night%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-04a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20black%20hair%20reading%20book%20in%20dim%20library%2C%20dusty%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-04b&orientation=landscape"
    ],
    description: "黑羽夜是学园里最年轻却最锋利的「夜刃」，一身黑衣冷得像化不开的夜。她把关心藏在讽刺里，把温柔藏在刀光后。",
    story: "夜幼年亲眼目睹家园被夜蚀吞没，从此立誓成为最强的夜刃。直到遇见那些愿意并肩的伙伴，她才慢慢卸下满身的防备。"
  },
  {
    id: "fujiwara-sakura",
    name: "藤原樱",
    alias: "Sakura / 樱公主",
    work: "樱色回忆录",
    workDesc: "《樱色回忆录》用温柔笔触记录少女与旧时光重逢的日常。",
    tags: ["天然", "治愈"],
    attributes: ["粉发", "长发", "和服"],
    cv: "上田丽奈",
    age: "15 岁",
    personality: "慢半拍，却对每个人都无比真诚",
    firstAppear: "第 1 话「花开时节」",
    popularity: 8760,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20long%20pink%20hair%20in%20soft%20kimono%2C%20cherry%20blossom%20pastel%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-05&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20pink%20hair%20walking%20under%20cherry%20blossoms%2C%20soft%20pastel%20spring%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-05a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20pink%20hair%20pouring%20tea%20in%20traditional%20room%2C%20warm%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-05b&orientation=landscape"
    ],
    description: "藤原樱说话总是慢悠悠的，但每一句都带着暖意。她记得镇上每个人的名字，也记得每一年花开的具体日子。",
    story: "樱守着祖母留下的旧茶屋，用一杯杯热茶招待每一位旅人。她的故事，是关于时间、陪伴与那些不会褪色的回忆。"
  },
  {
    id: "aoi-mint",
    name: "苍井薄荷",
    alias: "Mint / 薄荷气泡",
    work: "薄荷气泡水",
    workDesc: "《薄荷气泡水》讲述海边小镇少女与夏日限定的清爽治愈故事。",
    tags: ["治愈", "天然"],
    attributes: ["蓝发", "短发", "水手服"],
    cv: "水濑祈",
    age: "14 岁",
    personality: "安静温柔，像夏夜的风一样让人放松",
    firstAppear: "第 1 话「夏天的味道」",
    popularity: 8120,
    isNew: true,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20short%20teal%20mint%20hair%20in%20sailor%20uniform%2C%20refreshing%20pastel%20sea%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-06&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20mint%20hair%20on%20seaside%20pier%20with%20soda%20in%20hand%2C%20cool%20pastel%20summer%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-06a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20mint%20hair%20sitting%20in%20sunset%20beach%2C%20gentle%20pastel%20warm%20tones%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-06b&orientation=landscape"
    ],
    description: "苍井薄荷在镇上开着一家小小的气泡水摊，招牌是只加一点点薄荷。她话不多，却总能在你最难过的午后递上一杯刚好冰的饮料。",
    story: "薄荷的夏天总是很短，但她把每一个夏天都装进了透明的玻璃瓶里。她的故事，是关于告别，也是关于如何把短暂变成永远。"
  },
  {
    id: "hino-homura",
    name: "火野炎",
    alias: "Homura / 烈焰之心",
    work: "烈焰少女",
    workDesc: "《烈焰少女》讲述热血少女为守护家园而战、越挫越勇的燃系物语。",
    tags: ["元气", "傲娇"],
    attributes: ["红发", "双马尾", "战斗服"],
    cv: "日笠阳子",
    age: "15 岁",
    personality: "热血直率，永远冲在最前面",
    firstAppear: "第 1 话「点燃」",
    popularity: 8940,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20red%20twin%20tails%20and%20battle%20outfit%2C%20energetic%20warm%20pastel%20orange%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-07&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20red%20hair%20with%20glowing%20flame%20aura%2C%20warm%20pastel%20orange%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-07a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20red%20hair%20leading%20friends%20on%20adventure%2C%20bright%20pastel%20sky%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-07b&orientation=landscape"
    ],
    description: "火野炎的口头禅是「再来一次」。她从不在第一次就成功，但永远会站起来第二次、第三次，直到赢为止。",
    story: "炎从小在火山脚下长大，脾气像岩浆一样滚烫。她的火焰最初只会灼伤自己，直到学会为别人而燃，才真正点亮了整片战场。"
  },
  {
    id: "tsukimi-suzuran",
    name: "月见铃兰",
    alias: "Suzuran / 银月铃兰",
    work: "月下铃兰",
    workDesc: "《月下铃兰》是一部融合古典美学与奇幻设定的优雅系作品。",
    tags: ["优雅", "冷系"],
    attributes: ["紫发", "长发", "和服"],
    cv: "能登麻美子",
    age: "17 岁",
    personality: "沉静优雅，一言一行都像诗",
    firstAppear: "第 3 话「月见之约」",
    popularity: 8560,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20long%20lavender%20purple%20hair%20in%20elegant%20kimono%2C%20moonlit%20pastel%20purple%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-08&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20lavender%20hair%20dancing%20under%20full%20moon%2C%20soft%20pastel%20purple%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-08a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20lavender%20hair%20in%20lily%20valley%20garden%2C%20dreamy%20pastel%20tones%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-08b&orientation=landscape"
    ],
    description: "月见铃兰会在每个满月之夜独自起舞，据说她的舞步能让枯萎的铃兰重新绽放。她优雅得像不属于这个世界。",
    story: "铃兰是古老月见家族的末裔，肩负着维系人间与月界平衡的使命。她的舞，既是仪式，也是她唯一能自由表达情感的方式。"
  },
  {
    id: "koneko-mimi",
    name: "小猫咪咪",
    alias: "Mimi / 喵",
    work: "喵星少女",
    workDesc: "《喵星少女》讲述来自喵星的少女寄居人类家庭后的搞笑温馨日常。",
    tags: ["萌系", "元气"],
    attributes: ["金发", "兽耳", "猫尾"],
    cv: "内田真礼",
    age: "12 岁",
    personality: "黏人爱撒娇，好奇心和食量一样大",
    firstAppear: "第 1 话「我，是猫」",
    popularity: 9230,
    isNew: true,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20blonde%20hair%20and%20cat%20ears%2C%20playful%20pastel%20peach%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-09&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20cat%20girl%20blonde%20hair%20napping%20in%20sunbeam%2C%20warm%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-09a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20cat%20girl%20blonde%20hair%20playing%20with%20yarn%20ball%2C%20cozy%20pastel%20room%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-09b&orientation=landscape"
    ],
    description: "小猫咪咪的一天由「吃饭、睡觉、撒娇」构成。她嘴上说着要征服地球，实际上一根逗猫棒就能让她缴械投降。",
    story: "咪咪从喵星偷偷溜到地球，被一位独居的少女收留。她渐渐发现，比起回到喵星当公主，她更想留在这个有温暖怀抱的地方。"
  },
  {
    id: "shigure-rin",
    name: "时雨铃",
    alias: "Rin / 雨铃",
    work: "时雨之夏",
    workDesc: "《时雨之夏》讲述梅雨季节里，少女们若即若离的青春心事。",
    tags: ["傲娇", "冷系"],
    attributes: ["黑发", "双马尾", "学院制服"],
    cv: "鬼头明里",
    age: "15 岁",
    personality: "口是心非，越在乎越嘴硬",
    firstAppear: "第 2 话「第一场雨」",
    popularity: 8890,
    isNew: false,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20black%20twin%20tails%20in%20school%20uniform%2C%20rainy%20pastel%20blue%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-10&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20black%20hair%20holding%20transparent%20umbrella%20in%20rain%2C%20moody%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-10a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20black%20hair%20blushing%20in%20classroom%20window%2C%20soft%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-10b&orientation=landscape"
    ],
    description: "时雨铃永远在说「才不是因为你」，但伞永远只带一把，还总往你那边偏。她的傲娇，是梅雨季里最明亮的风景。",
    story: "铃和主角的相遇始于一场突如其来的雨。她用整个夏天来否认自己的心意，却在最后一场雨里，终于说出了那句迟到的话。"
  },
  {
    id: "shiraishi-momo",
    name: "白石茉茉",
    alias: "Momo / 草莓茉茉",
    work: "草莓甜心",
    workDesc: "《草莓甜心》讲述少女在甜品店打工的甜美日常与梦想故事。",
    tags: ["萌系", "治愈"],
    attributes: ["粉发", "短发", "头饰"],
    cv: "小仓唯",
    age: "13 岁",
    personality: "软萌心细，做甜品时会发光",
    firstAppear: "第 1 话「第一块蛋糕」",
    popularity: 8080,
    isNew: true,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20short%20pastel%20pink%20hair%20and%20strawberry%20hair%20accessory%2C%20sweet%20pastel%20pink%20bakery%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-11&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20pink%20hair%20decorating%20strawberry%20cake%20in%20bakery%2C%20warm%20pastel%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-11a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20pink%20hair%20smiling%20behind%20counter%20full%20of%20sweets%2C%20cozy%20pastel%20tones%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-11b&orientation=landscape"
    ],
    description: "白石茉茉的梦想是做出「能让人笑出来的蛋糕」。她的手总是沾着面粉，眼睛却亮得像刚撒上的糖霜。",
    story: "茉茉在家乡的小甜品店长大，为了成为真正的西点师独自来到城市。她相信只要用心，再简单的甜点也能传递幸福。"
  },
  {
    id: "kohaku-rico",
    name: "琥珀莉可",
    alias: "Rico / 冒险家",
    work: "琥珀色的冒险",
    workDesc: "《琥珀色的冒险》讲述少女探险家与伙伴环游世界、追寻传说的热血旅程。",
    tags: ["元气", "萌系"],
    attributes: ["橙发", "短发", "探险帽"],
    cv: "高桥李依",
    age: "14 岁",
    personality: "胆大心细，好奇心能掀翻整个地图",
    firstAppear: "第 1 话「出发那天」",
    popularity: 8450,
    isNew: true,
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20with%20short%20orange%20hair%20and%20adventure%20hat%2C%20warm%20sunny%20pastel%20background%2C%20kawaii%20anime%20illustration%20style%2C%20wholesome%2C%20high%20detail&width=600&height=800&seq=role-cover-12&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=anime%20girl%20orange%20hair%20exploring%20ancient%20ruins%2C%20warm%20pastel%20golden%20light%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-12a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=anime%20girl%20orange%20hair%20on%20hot%20air%20balloon%20over%20mountains%2C%20bright%20pastel%20sky%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=role-g-12b&orientation=landscape"
    ],
    description: "琥珀莉可的背包里永远装着半张残缺的藏宝图。她去过的地方比大人还多，唯一的行李是无所畏惧的笑容。",
    story: "莉可继承了祖父未完成的航海日志，为了寻找地图尽头那座「琥珀之城」而出发。她相信，最精彩的故事永远在下一段路上。"
  }
];